<template>
  <footer
    class="footer"
    :style="componentStyle"
    v-if="section.columns.length"
  >
    <div class="container footer__columns">
      <template
        v-for="(column, columnIndex) in section.columns"
        :key="`column_${columnIndex}`"
      >
        <section
          class="footer__blocks"
          v-if="column.blocks.length"
        >
          <template
            v-for="(block, blockIndex) in column.blocks"
            :key="`block_${blockIndex}_from_column_${columnIndex}`"
          >
            <app-component-loader
              v-if="block.path && block.is_visible"
              :objects="{ parent: section, component: block }"
              :component-path="block.path"
            />
          </template>
        </section>
      </template>
    </div>
  </footer>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useStyle } from '@/composables/app/useStyle'

const AppComponentLoader = defineAsyncComponent(() => import('&/atoms/AppComponentLoader'))

const { section } = defineProps({ section: { type: Object, required: true } })

const { componentStyle } = useStyle(section.style)
</script>

<style lang="scss" scoped>
.footer {
  background-color: $white;
  padding: 36px 0;

  &__columns {
    display: grid;
    grid-template-columns: 1fr;
    gap: 36px;

    @include mq(sm) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include mq(md) {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }

  &__blocks {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
}
</style>
